import React, { useEffect } from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { Image } from 'expo-image';
import { StatusBar } from 'expo-status-bar';
import { getLoggedInStudentId, getUserSnapshot } from '../utils/sessionUser';
import { isYoutubeOAuthInProgress } from '../utils/youtubeOAuthFlow';

const SPLASH_IMAGE_URL = 'https://mingchuan.ie/wp-content/uploads/2016/12/cropped-head.jpg';

export default function SplashScreen({ navigation }) {
  useEffect(() => {
    let cancelled = false;
    let timer = null;

    (async () => {
      const [studentId, snapshot] = await Promise.all([
        getLoggedInStudentId(),
        getUserSnapshot(),
      ]);
      if (cancelled) return;

      if (studentId != null && snapshot) {
        navigation.replace('MainPage', { user: snapshot, userId: studentId });
        return;
      }

      const oauthReturn = Platform.OS === 'web' && isYoutubeOAuthInProgress();
      const delayMs = oauthReturn ? 0 : 3000;
      timer = setTimeout(() => {
        if (!cancelled) navigation.replace('Login');
      }, delayMs);
    })();

    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
  }, [navigation]);

  return (
    <View style={styles.container} data-screen="splash">
      <StatusBar style="light" />
      <View style={styles.imageContainer}>
        <Image
          source={{ uri: SPLASH_IMAGE_URL }}
          style={styles.image}
          contentFit="contain"
          transition={200}
          onError={(error) => {
            console.error('Error loading splash image:', error);
          }}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#000000',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  imageContainer: {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: '#000000',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '100%',
    height: '100%',
    backgroundColor: '#000000',
  },
});
